import { defineStore } from 'pinia'
export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    previous_user: null,
    intended_url: null,
  }),
  actions: {
    set_user(user) {
      this.user = user
    },
    set_intended_url(intendedUrl) {
      this.intended_url = intendedUrl
    },
    async attempt_user() {
      try {
        const { data } = await axios.get('/api/v1/me')

        this.user = data.current_user
        this.previous_user = data.previous_user || null
        return data.current_user
      }
      catch(e) {
        this.user = null
      }
    },
    async logout() {
      return axios.post('/logout')
        .then((response) => {
          this.router.push('/')
          this.$reset()
        })
        .catch((error) => {
          console.error(error)
          throw error
        })
    },
    async loginViaToken(token) {
      await axios.get('/sanctum/csrf-cookie');
      const loginResponse = await axios.post('/api/login-via-token', {token:token})
      if (loginResponse?.status === 200 && loginResponse.data?.two_factor) {
        await this.router.push({ name: 'TwoFactorChallenge' })
        return
      }
      const payload = await this.attempt_user()
      if (this.user && payload.redirect_to) {
        await this.router.push(payload.redirect_to)
      }
    },
    async login(payload, noRedirect) {
      await axios.get('/sanctum/csrf-cookie');
      const loginResponse = await axios.post('/login', payload)

      if (loginResponse?.status === 200 && loginResponse.data?.two_factor) {
        await this.router.push({ name: 'TwoFactorChallenge' })
        return
      }
      await this.attempt_user()
      if (this.user && payload.redirect_to) {
        await this.router.push(payload.redirect_to)
      }
      else if(this.user && this.intended_url) {
        console.log('redirecting to intended url', this.intended_url)
        await this.router.push(this.intended_url)
        this.intended_url = null
      }
      else if(this.user && !noRedirect) {
        await this.router.push({ name: 'DashboardPage' })
      }
    },
    async startImpersonation(userId) {
      const { data } = await axios.post(`/api/v1/impersonate/${userId}`,{
        source_url: this.router.currentRoute.value.fullPath
      })
      this.user = data.user
      this.previous_user = data.previous_user || null
      await this.attempt_user()
    },
    async stopImpersonation() {
      const { data } = await axios.post(`/api/v1/impersonate-stop`)
      this.previous_user = null
      this.user = data.user
      if(data.original_url_source) {
        await this.router.push(data.original_url_source)
      }
    }
  },
  getters: {
    currentUser: (state) => state.user,
    previousUser: (state) => state.previous_user,
  },
})
